import create from 'zustand';

interface FeatureAnnouncementStore {
  isFeatureModalVisible: boolean;
  setFeatureModalVisible: (visible: boolean) => void;
  dismissedFeatures: Set<string>;
  dismissFeature: (featureId: string) => void;
  isFeatureDismissed: (featureId: string) => boolean;
}

export const useFeatureAnnouncementStore = create<FeatureAnnouncementStore>(
  (set, get) => ({
    isFeatureModalVisible: false,
    setFeatureModalVisible: (visible) =>
      set({ isFeatureModalVisible: visible }),
    dismissedFeatures: new Set(),
    dismissFeature: (featureId) => {
      const { dismissedFeatures } = get();
      const newDismissedFeatures = new Set(dismissedFeatures);
      newDismissedFeatures.add(featureId);

      // Store in localStorage
      localStorage.setItem(`featureDismissed_${featureId}`, 'true');

      set({
        dismissedFeatures: newDismissedFeatures,
        isFeatureModalVisible: false,
      });
    },
    isFeatureDismissed: (featureId) => {
      const { dismissedFeatures } = get();
      if (dismissedFeatures.has(featureId)) {
        return true;
      }

      // Check localStorage
      const isDismissed =
        localStorage.getItem(`featureDismissed_${featureId}`) === 'true';
      if (isDismissed) {
        const newDismissedFeatures = new Set(dismissedFeatures);
        newDismissedFeatures.add(featureId);
        set({ dismissedFeatures: newDismissedFeatures });
        return true;
      }

      return false;
    },
  }),
);
